var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product-search-widget"},[_c('PopupSearchWidget',{ref:"searchWidget",attrs:{"title":_vm.$t('product.search'),"width":800,"action":_vm.handleSearch,"columns":_vm.columns,"selectedRowTitle":_vm.productName,"selectedRowId":_vm.productId,"defaultData":_vm.products,"disabled":_vm.disabled},on:{"on-select":_vm.handleChanged}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }